let renderingState: 'initial' | 'client-hydrated' = 'initial';

const listeners: (() => void)[] = [];

// Actions

export function setClientHydrated() {
  renderingState = 'client-hydrated';
  listeners.forEach((listener) => listener());
}

// Hooks

export function isRenderingServer() {
  return renderingState === 'initial' ? typeof window === 'undefined' : false;
}

// This variable is replaced during build time
export const HORIZON_ENABLED = false;

export function isRenderingHorizonServer() {
  return isRenderingServer() && HORIZON_ENABLED;
}

export function isClientHydrated() {
  return renderingState === 'client-hydrated';
}

export function onClientHydrated(fn: () => void) {
  if (isClientHydrated()) {
    fn();
    return;
  }

  listeners.push(fn);
}
